import {AxiosInstance} from "axios";
import LatLng from "../model/map/LatLng";
import MapUtils from "../utils/MapUtils";
import {Option} from "ts-option";

/**
 * Google api wrapper.
 */
export default class GoogleApi {
	constructor(public readonly axiosInstance: AxiosInstance) { }

	/**
	 * Get location for given address.
	 * @returns {Promise<Option<LatLng>>} Promise containing location for given address.
	 */
	getLocationFromAddress(address: string): Promise<Option<LatLng>> {
		const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURI(address)}&key=${MapUtils.API_KEY}`;
		return this.axiosInstance.get(url).then(resp => LatLng.fromJson(resp.data))
	}
}